import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserManagementService } from 'src/app/services/user-management.service'; 
import { SharedConfiguration } from 'src/app/models/configuration.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  sharedConfigurations: SharedConfiguration[] = [
    { id: 1, name: 'Shared Configurations', active: true, routerURL: '/settings/mmssetting' },
    { id: 2, name: 'State Configurations', active: true, routerURL: '/settings/statesetting' },
    { id: 3, name: 'Pharmacy Configurations', active: true, routerURL: '/settings/pharmacysetting' },
    { id: 4, name: 'Admin Settings', active: true, routerURL: '/settings/adminsetting' }
  ];
  
  userConfigurationIds: number[] = [];

  constructor(private authService: AuthService, public router: Router, private userManagementService: UserManagementService) {}

  ngOnInit(): void {
    this.lockSharedConfigurationsBasedOnPermissions();
  }

  logout(){
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  lockSharedConfigurationsBasedOnPermissions() {
    const loggedInUser = this.authService.getLoggedInUser();
    
    if (loggedInUser) {
      this.userManagementService
        .getUserConfigurationIds(loggedInUser?.email || '')
        .subscribe(ids => { 
          this.userConfigurationIds = ids;
        });
      console.log('User Configuration IDs:', this.userConfigurationIds);
    }
    
  }

  hasPermission(configId: number): boolean {
    return this.userConfigurationIds.includes(configId);
  }

  getActiveConfigurations(): SharedConfiguration[] {
    return this.sharedConfigurations.filter(config => config.active);
  }
}
